
    <div class="main-nav">
            <div class="row">
                <div class="col-7">
                    <img style="margin-bottom:20px;" height="35px" src="assets/img/logo/digimet-logo.png" alt="digimet-logo">
                    <a class="navbar-brand" href="#">
                        <span class="nav-brand-l konkhmer">DIGIMET</span>
                        <span class="nav-brand-m konkhmer">Connect</span>
                    </a>
                </div>
            </div>
    </div>
    <div class="container">
        <div class="row">
            <!--  form for confirmation and go to login -->
            <div class="login-form">
                <div class="text-center mt-5">
                    <h4 class="konkhmer">パスワードが設定されました</h4>
                </div>
                <div style="height: 250px;">
                </div>
                <div class="text-center mt-3">
                  <button  type="submit" (click)="onSubmit()" class="btn login-btn">ログイン</button>
                </div>
            </div>
        </div>
    </div>
